import "./App.css";
import Header from "./MyComponents/Home/Header";
import Footer from "./MyComponents/Home/Footer";
import LeftSideBar from "./MyComponents/Home/LeftSideBar";
import RightSideBar from "./MyComponents/Home/RightSideBar";
import Carousal from "./MyComponents/Home/Carousal";
import BestDeals from "./MyComponents/Home/Featured";
import CardDetail from "./MyComponents/Home/CardDetail";
import SearchResult from "./MyComponents/Home/SearchResult";
import InventoryAddForm from "./MyComponents/Admin/CarInventory/add-car";
import About from "./MyComponents/About/About";
import AllCars from "./MyComponents/Home/Inventory";
import Login from "./MyComponents/Auth/Login";
import Signup from "./MyComponents/Auth/Signup";
import ContactUs from "./MyComponents/Contact/ContactUs";
import WhatsAppFab from "./MyComponents/Whatsapp/WhatsAppFab";
import ScrollToTop from "./MyComponents/Home/ScrollToTop";
import InventoryDeleteForm from "./MyComponents/Admin/CarInventory/delete-car";
import Testimonials from "./MyComponents/Home/Testimonials";
import AdminPanel from "./MyComponents/Admin/AdminPanel/AdminPanel";
import NotAuthorized from "./MyComponents/pages/NotAuthorized";
import ProtectedAdminRoute from "./MyComponents/Admin/AdminPanel/ProtectedAdminRoute";
import InventoryFeatureForm from "./MyComponents/Admin/CarInventory/feature-car";
import CreateInvoice from "./MyComponents/Admin/Invoice/CreateInvoice";

import { GoogleOAuthProvider } from "@react-oauth/google";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import { AuthProvider } from "./Firebase//authContext";

function Home() {
  return (
    <div className="main-content-area">
      <LeftSideBar />
      <div className="main-content">
        <div className="carousel-container">
          <Carousal />
        </div>
        <div className="best-deal-container">
          <BestDeals />
        </div>
        <div className="testimonials-container">
          <Testimonials />
        </div>
      </div>
      <RightSideBar />
    </div>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="app-container">
            <Header />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/card-details/:recordNumber" element={<CardDetail />} />
              <Route path="/search" element={<SearchResult />} />
              <Route path="/home/Inventory" element={<AllCars />} />
              <Route path="/Inventory" element={<AllCars />} />
              <Route path="/aboutus" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/contactus" element={<ContactUs />} />

              <Route
                path="/admin"
                element={
                  <ProtectedAdminRoute>
                    <AdminPanel />
                  </ProtectedAdminRoute>
                }
              />

              <Route
                path="/InventoryAddForm"
                element={
                  <ProtectedAdminRoute>
                    <InventoryAddForm />
                  </ProtectedAdminRoute>
                }
              />

              <Route
                path="/InventoryDeleteForm"
                element={
                  <ProtectedAdminRoute>
                    <InventoryDeleteForm />
                  </ProtectedAdminRoute>
                }
              />

              <Route
                path="/InventoryFeatureForm"
                element={
                  <ProtectedAdminRoute>
                    <InventoryFeatureForm />
                  </ProtectedAdminRoute>
                }
              />

              <Route
                path="/admin/create-invoice"
                element={
                  <ProtectedAdminRoute>
                    <CreateInvoice />
                  </ProtectedAdminRoute>
                }
              />

              <Route path="/not-authorized" element={<NotAuthorized />} />
            </Routes>

            <Footer />
            <WhatsAppFab />
          </div>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;